import { FC } from 'react'

import cl from './Switcher.module.scss'

export interface SwitcherProps {
	isChecked: boolean
	handleChange: () => void
}

export const Switcher: FC<SwitcherProps> = ({ isChecked, handleChange }) => {
	return (
		<div className={cl.root}>
			<input type="checkbox" className={cl.input} checked={isChecked} onChange={handleChange} />{' '}
			<p>Оплата другим способом</p>
		</div>
	)
}
